<template>
  <div class="mb-3 mt-5">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('password_reset.title') }}</h1>
      <password-reset-form></password-reset-form>
    </b-container>
  </div>
</template>

<script>
import PasswordResetForm from '../components/PasswordResetForm'
export default {
  name: 'PasswordReset',
  components: { PasswordResetForm }
}
</script>

<style scoped>

</style>
